import { APIList } from '@/api';

const api = new APIList();

export default {

  fileDownload({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.fileDownload(ID,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getAllSelections({ commit }, selectionType) {
    return new Promise((resolve, reject) => {
      api.getAllSelections(selectionType,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  searchOption({ commit }, payload) {

    var params = {
      type: payload.optionType,
      ...payload.searchInput
    }

    return new Promise((resolve, reject) => {
      api.autoSearch(payload.dest, params,
        (json) => {
          switch (json.status) {
            case 200:
              resolve(json.data.list);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  },

  deleteDocument({ state }, ID) {
    return new Promise((resolve, reject) => {
      api.fileDelete(ID, (json) => {
          switch (json.status) {
            case 200:
              resolve(json);
              break;
            default:
              reject(json);
              break;
          }
        },
        (err) => {
          reject(err);
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js